import { DebounceTime, type HostedObserverConfig } from "@coze-studio/autosave";

import { type ParameterStoreProps, ParameterType } from "@rokid/store";
import { type ParameterConfig, ItemType } from "./type.ts";

type RegisterInputParameterConfig = HostedObserverConfig<
  ParameterStoreProps,
  ItemType,
  ParameterConfig
>;

export const inputParameterConfig: RegisterInputParameterConfig = {
  key: ItemType.customParms,
  selector: (store) => {
    console.log('cutP config:',store)
    return {
      param_list:store.param_list
    }
  },
  debounce: {
    default: DebounceTime.Immediate,
    customized_suggest_prompt: DebounceTime.Long,
  },
  middleware: {
    onBeforeSave: (dataSource) => {
      console.log('cutP onBeforeSave:',dataSource)
      return {
        param_list:dataSource.param_list
      }
    },
  },
};
